import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from 'route/Router';
import { store } from 'redux/store';
import { Provider } from 'react-redux';

import 'assets/styles/global.css';
import 'devextreme/dist/css/dx.light.css';
import SnackBar from 'pages/Modules/SnackBar/SnackBar';
import { setRuntimeApiUrl, getRuntimeApiUrl, resetRuntimeApiUrl } from 'constant/Varible';

if (
  process.env.NODE_ENV === 'production' &&
  !window.location.href.includes('localhost')
) {
  Sentry.init({
    dsn: 'https://5cd80ff0d1733253f890ef186ff08c27@o4505241347489792.ingest.sentry.io/4505839586836480',
    integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
if (typeof window !== 'undefined') {
  window.setApiUrl = setRuntimeApiUrl;
  window.getApiUrl = getRuntimeApiUrl;
  window.resetApiUrl = resetRuntimeApiUrl;
}
root.render(
  <Provider store={store}>
    <App />
    <SnackBar />
  </Provider>
);
